import React, { Component } from "react";

const RegisterAsLawyer = () => {
  return <h1>Register As Lawyer</h1>;
};

export default RegisterAsLawyer;
